import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=4e7c9004&lang=pug&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7c9004')) {
      api.createRecord('4e7c9004', component.options)
    } else {
      api.reload('4e7c9004', component.options)
    }
    module.hot.accept("./comments.vue?vue&type=template&id=4e7c9004&lang=pug&", function () {
      api.rerender('4e7c9004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comments.vue"
export default component.exports